// extracted by mini-css-extract-plugin
export default {"schedule-input__title":"ScheduleInput_schedule-input__title__GGFFj"};